import { render, staticRenderFns } from "./IrisCloakedCheckmark.vue?vue&type=template&id=0861ecb0&"
import script from "./IrisCloakedCheckmark.vue?vue&type=script&lang=ts&"
export * from "./IrisCloakedCheckmark.vue?vue&type=script&lang=ts&"
import style0 from "./IrisCloakedCheckmark.vue?vue&type=style&index=0&id=0861ecb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports